/**
 * ============================================================================
 *   Copyright (c) 2026 Dobler Data Solutions, LLC. ALL RIGHTS RESERVED.
 * ============================================================================
 *   Module       : autoRefresh (config)
 *   Feature      : 226-universal-page-affordances
 *   Description  : Single source of truth for the auto-refresh policy — the
 *                  route prefixes that auto-refresh and the fixed interval. The
 *                  interval is read by useAutoRefresh; the prefixes are read by the
 *                  conformance guard (scripts/check_page_affordances.py), which adds
 *                  every route in the menu's Insights section, so the two never drift.
 *   Constitution : v1.23.0
 *   Author       : Peter Dobler
 *   Created      : 2026-07-07
 * ============================================================================
 */

/** Fixed 5-minute cadence for dashboards + insights (Clarify 2026-07-07 — not per-user configurable). */
export const AUTO_REFRESH_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Route prefixes whose pages auto-refresh. `/dashboard` covers the role
 * dashboards (DashboardRouter); `/insights` covers the insight pages routed
 * there. Insight pages routed under `/operations/` are named by the menu's
 * Insights section (MenuConfig.ts), which the guard reads as well.
 */
export const AUTO_REFRESH_PREFIXES = ['/dashboard', '/insights'] as const;
